'use client'

import { memo } from 'react'

const VaultRatingsError = () => {
  return <span className="text-foreground text-xs">Unable to load ratings for this vault.</span>
}

export default memo(VaultRatingsError)
